import { environment } from 'src/environments/environment';

export function assetUrl(path: string){
  return environment.ASSET_URL + path;
}
